import { createAction } from "redux-actions";
import { createPromiseAction } from "../../utils/createPromiseAction";

export const ADD_CATEGORY_REQUEST = "category/ADD_CATEGORY_REQUEST";
export const ADD_CATEGORY_SUCCESS = "category/ADD_CATEGORY_SUCCESS";

export const GET_CATEGORIES_REQUEST = "category/GET_CATEGORIES_REQUEST";
export const GET_CATEGORIES_SUCCESS = "category/GET_CATEGORIES_SUCCESS";

export const categoryActions = {
  addCategory: createPromiseAction(ADD_CATEGORY_REQUEST),
  addCategorySuccess: createAction(ADD_CATEGORY_SUCCESS),
  getCategories: createPromiseAction(GET_CATEGORIES_REQUEST),
  getCategoriesSuccess: createAction(GET_CATEGORIES_SUCCESS),
};
